import {FC, useEffect, useMemo, useState} from 'react'
import {find, truncate} from 'lodash'
import {Dropdown} from 'react-bootstrap'
import {globalFilter} from 'app/constant'
import {orderLookupsService} from 'app/services/OrdersService'

type Props = {
  filter: any
  onChange: (value: any) => any
}

const OrderWineClubFilter: FC<Props> = ({filter, onChange}) => {
  const [wineClubs, setWineClub] = useState<any[]>([])

  useEffect(() => {
    const fetch = async () => {
      const data = await orderLookupsService.getWineClub()
      setWineClub(data)
    }
    fetch()
  }, [])

  const handleChange = (id: any) => {
    let wineClubId
    if (id === '') {
      wineClubId = null
    } else {
      wineClubId = id
    }
    onChange({...filter, wineClubId, offset: 0, totalWeight: null})
  }

  const filterName = useMemo(() => {
    if (filter.wineClubId && wineClubs) {
      const order = find(wineClubs, {id: filter.wineClubId})
      if (order?.id) {
        return order?.name
      }
    }
    return 'Wine Clubs'
  }, [filter.wineClubId, wineClubs])

  return (
    <Dropdown>
      <Dropdown.Toggle variant='transparent' className={`${globalFilter.css} mt-1`}>
        {filterName}
      </Dropdown.Toggle>
      <Dropdown.Menu className='form-control border-dark border ms-1 mt-1'>
        <Dropdown.Item eventKey='' as='button' onSelect={handleChange}>
          All
        </Dropdown.Item>
        {wineClubs.map((wineClub) => (
          <Dropdown.Item
            key={wineClub.id}
            eventKey={wineClub.id}
            as='button'
            onSelect={handleChange}
          >
            {truncate(wineClub.name, {length: 15})}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default OrderWineClubFilter
